module.exports = __webpack_public_path__ + "static/media/undraw_conversation_re_c26v.8d6593cb.svg";